
import { FC } from "react";
import { CaseCard } from "./CaseCard";
import { CaseListItem } from "@/types";

interface CasesListProps {
  cases: CaseListItem[];
}

export const CasesList: FC<CasesListProps> = ({ cases }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {cases.map((caseItem) => (
        <CaseCard key={caseItem.id} caseData={caseItem} />
      ))}
    </div>
  );
};
